module.exports = __webpack_public_path__ + "img/avatar-bg-3rd.db29467a.png";